var cov_27zdyoecfh = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/isJson.ts",
      hash = "9feeceea8967988efb42302a87f7c8f0b2e11d43",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/isJson.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 44
        }
      },
      "1": {
        start: {
          line: 2,
          column: 33
        },
        end: {
          line: 2,
          column: 44
        }
      },
      "2": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "4": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 33,
          column: 7
        }
      },
      "5": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 25
        }
      },
      "6": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 19
        }
      },
      "7": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 20
        }
      },
      "8": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 18
        }
      },
      "9": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 40
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 44
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 44
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function (value) {
  cov_27zdyoecfh.f[0]++;
  cov_27zdyoecfh.s[0]++;

  if (typeof value === 'object') {
    cov_27zdyoecfh.b[0][0]++;
    cov_27zdyoecfh.s[1]++;
    return true;
  } else {
    cov_27zdyoecfh.b[0][1]++;
  } // In the second stage, we run the text against
  // regular expressions that look for non-JSON patterns. We are especially
  // concerned with '()' and 'new' because they can cause invocation, and '='
  // because it can cause mutation. But just to be safe, we want to reject all
  // unexpected forms.
  // We split the second stage into 4 regexp operations in order to work around
  // crippling inefficiencies in IE's and Safari's regexp engines. First we
  // replace all backslash pairs with '@' (a non-JSON character). Second, we
  // replace all simple value tokens with ']' characters. Third, we delete all
  // open brackets that follow a colon or comma or that begin the text. Finally,
  // we look to see that the remaining characters are only whitespace or ']' or
  // ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.
  // eslint-disable-next-line


  cov_27zdyoecfh.s[2]++;

  if (typeof value === 'string') {
    cov_27zdyoecfh.b[1][0]++;
    cov_27zdyoecfh.s[3]++;

    if (/^[\],:{}\s]*$/.test(value.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      cov_27zdyoecfh.b[2][0]++;
      cov_27zdyoecfh.s[4]++;

      try {
        cov_27zdyoecfh.s[5]++;
        JSON.parse(value);
        cov_27zdyoecfh.s[6]++;
        return true;
      } catch (e) {
        cov_27zdyoecfh.s[7]++;
        return false;
      }
    } else {
      cov_27zdyoecfh.b[2][1]++;
      cov_27zdyoecfh.s[8]++;
      return false;
    }
  } else {
    cov_27zdyoecfh.b[1][1]++;
    cov_27zdyoecfh.s[9]++;
    return false;
  }
}